export default function setSearchFOEAction(searchFOE) {
    return {
        type: 'SET_SEARCH_FOE',
        payload: searchFOE
    }
}